<template>
  <div data-module="image" v-if="visible">
    <img :src="output" />
  </div>
</template>

<script>
export default {
  name: 'module_image',
  props: ['data', 'window'],
  computed: {
    visible: function() {
      const visibility = this.data.visibility;
      if (!visibility) {
        return true;
      }

      let visible = true;
      if (this.window.width <= visibility.min) {
        visible = false;
      }

      if (this.window.width > visibility.max) {
        visible = false;
      }

      return visible;
    },
    output: function() {
      let output;
      const window = this.window;

      if (this.data.srcSet) {
        output = this.data.srcSet.find(function(img) {
          return window.width < img.max;
        });
      }

      if (output) {
        output = output.src;
      } else {
        output = this.data.src;
      }

      return output;
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

[data-module="image"] {
  @include spacer();

  img {
    display: block;
    max-width: 100%;
    margin: auto;
  }
}
</style>




// WEBPACK FOOTER //
// src/modules/image.vue